import { CardElement } from '@stripe/react-stripe-js';
import { Col, Form, Row } from 'antd';
import React from 'react';

import Checkbox from '../../../../components/Checkbox';
import TextInput from '../../../../components/TextInput';
import { ERROR_MESSAGE } from '../../../../utils/constants';

const CreditCardForm = props => {
  const {
    t,
    isUpdate,
    formInstance,
    initialValues,
    isSubmitting,
    onCardReady,
    onCardChange,
    cardError,
  } = props;

  return (
    <Form form={formInstance} labelCol={{ span: 24 }} initialValues={initialValues}>
      <Row gutter={17}>
        {isUpdate && (
          <Col xs={24}>
            <Form.Item label={t('cardNumber')} name="cardNumber">
              <TextInput disabled placeholder={t('enterCardNumber')} autoComplete="cc-number" />
            </Form.Item>
          </Col>
        )}

        <Col xs={24}>
          <Form.Item
            required
            label={t('cardholderName')}
            name="name"
            rules={[{ required: true, message: ERROR_MESSAGE().BLANK_FIELD }]}
          >
            <TextInput
              required
              autoComplete="cc-name"
              disabled={isSubmitting}
              placeholder={t('enterCardholdername')}
            />
          </Form.Item>
        </Col>

        {isUpdate && (
          <Col xs={24} md={12}>
            <Form.Item
              required
              label={t('expirationDate')}
              name="expirationDate"
              rules={[{ required: true, message: ERROR_MESSAGE().BLANK_FIELD }]}
            >
              <TextInput
                masked
                mask="00 / 00"
                autoComplete="cc-exp"
                placeholder="MM / YY"
                disabled={isSubmitting}
              />
            </Form.Item>
          </Col>
        )}

        {!isUpdate && (
          <Col xs={24}>
            <Form.Item
              required
              label={t('creditCard')}
              validateStatus={cardError ? 'error' : undefined}
              help={cardError}
            >
              <CardElement
                onReady={onCardReady}
                onChange={onCardChange}
                options={{
                  disabled: isSubmitting,
                  hidePostalCode: true,
                  style: { base: { fontSize: '16px' } },
                }}
              />
            </Form.Item>
          </Col>
        )}
      </Row>

      <Row gutter={10} align="middle">
        <Col flex={1}>
          <Form.Item
            hidden={isUpdate}
            name="isDefault"
            valuePropName="checked"
            className="no-margin-bottom"
          >
            <Checkbox disabled={isSubmitting}>{t('setAsDefault')}</Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CreditCardForm;
